import { ReferenceEntity } from 'src/utils/reference-schema';
import { TypeDefinitionSyntax, useTypeDefinition } from './type-definition-context';
import { TypeDefinitionDeclaration } from './type-definition-declaration';
import { TypeDefinitionObject } from './type-definition-object';
import { TypeDefinitionParameters } from './type-definition-parameters';
import { TypeDefinitionReturn } from './type-definition-return';

/** Pieces together the type definition for any API Reference entity. */
export const TypeDefinitionEntity = () => {
  const {
    entity,
    language
  } = useTypeDefinition();
  const returnFirst = ['dotnet', 'java'].includes(language);
  if (entity.properties) {
    return <>
        <TypeDefinitionDeclaration />
        <TypeDefinitionObject />
      </>;
  }
  return <>
      {returnFirst && <TypeDefinitionReturn />}
      <TypeDefinitionDeclaration data-sentry-element="TypeDefinitionDeclaration" data-sentry-source-file="type-definition-entity.tsx" />
      <span className="token punctuation">(</span>
      <TypeDefinitionParameters data-sentry-element="TypeDefinitionParameters" data-sentry-source-file="type-definition-entity.tsx" />
      <span className="token punctuation">)</span>
      {!returnFirst && <TypeDefinitionReturn />}
    </>;
};
export const methodRegExp = /(\w+\()(.*)(\))$/;
export const getSyntax = (entity: ReferenceEntity): TypeDefinitionSyntax => {
  // Indexed arrays
  if (entity.type?.includes('[]')) {
    return 'array';
  }

  // Indexed arrays special-cased for PHP list methods
  //
  // We normally treat PHP arrays as "object" syntax because almost all arrays we have are associative.
  // However, list methods use indexed arrays, which need to use the proper "array" syntax
  const isListEntity = entity.properties?.find(({
    key
  }) => key === 'before');
  if (entity.type === 'array' && isListEntity) {
    return 'array';
  }

  // Class declarations
  if (entity.title?.startsWith('class')) {
    return 'class';
  }

  // Class declarations special-cased for PHP classes
  if (entity.title?.startsWith('WorkOS\\')) {
    return 'class';
  }
  if (entity.type === 'map[string]interface{}') {
    return 'map';
  }

  // Everything else is treated like an object/map/hash/struct etc.
  return 'object';
};